export default __webpack_public_path__ + "static/media/delete.c184eb9e.svg";